const doc = [({"ko":({"adminConstantInventoryUnit":({"guest":"손님 증가/감소", "room":"방의 증가/감소"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;